module.exports = __webpack_public_path__ + "img/cnsa.e15f9827.png";